'use client';

import { FORWARDED_PARAM_KEYS } from 'components/shared/CustomLink';
import React from 'react';

const params = FORWARDED_PARAM_KEYS;

export const useForwardSearchParams = (): ((url: string) => string) => {
  const [currentLocationSearch, setCurrentLocationSearch] = React.useState('');

  React.useEffect(() => {
    setCurrentLocationSearch(document.location.search);
  }, []);

  return (url: string) => {
    const newUrl = new URL(url);

    const linkSearchParams = new URLSearchParams(newUrl.search);
    const documentSearchParams = new URLSearchParams(currentLocationSearch);

    params.forEach((param) => {
      const value = documentSearchParams.get(param);
      if (value) linkSearchParams.set(param, value);
    });

    newUrl.search = linkSearchParams.toString();

    return newUrl.href;
  };
};
